<template>
  <div class="mainChild page-content" id="lowPriceDetails">
    <div>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>智慧服务</el-breadcrumb-item>
        <el-breadcrumb-item :to="toPath">日常违规检索</el-breadcrumb-item>
        <el-breadcrumb-item>检索违规详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="headerBrand">
      <section class="seaerch-wrapper">
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="商品标题" :label-width="formLabelWidth">
            <el-input :clearable="true" placeholder="请输入商品标题" v-model="list.itemtitle" size="small"></el-input>
          </el-form-item>
          <el-form-item label="平台" :label-width="formLabelWidth" v-if="platformShow == true">
            <el-select v-model="list.platform" filterable placeholder="请选择" size="small">
              <el-option label="淘宝天猫" value="TBTM"></el-option>
              <el-option label="淘宝" value="TB"></el-option>
              <el-option label="天猫" value="TM"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="店铺名称" :label-width="formLabelWidth">
            <el-input :clearable="true" placeholder="请输入店铺名称" v-model="list.shopname" size="small"></el-input>
          </el-form-item>
          <el-form-item label="产品信息" :label-width="formLabelWidth">
            <el-input
              :clearable="true"
              placeholder="请输入产品信息"
              v-model="list.productName"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item></el-form-item>
          <el-form-item></el-form-item>
          <el-form-item style="margin-top: 4px;">
            <el-button size="small" class="search-btn" @click="getIprPluginListList(1)">查  询</el-button>
          </el-form-item>
        </el-form>
      </section>
    </div>
    <div class="downContainer">
      <div class="downBtn">
        <!-- <el-button @click="delBatches" type="small" v-show='showType'>批量删除</el-button> -->
        <el-button size="small" type="primary" :loading="lowPriceLoading" v-if="logintype != 'KEFU'" @click="exportExcelStatistics">下载数据</el-button>
        <el-button @click="productShow = true" size="small" type="primary" :loading="lowPriceLoading" v-else>下载数据</el-button>
      </div>
      <div class="prompt">
        <i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
        共
        <span v-show='showType'>
            <span class="promptFont">{{total}}</span>项
        </span>
        <span v-show='!showType'>{{total}}  项违规商品，检索数据时间：{{$route.query.date}}。</span>
      </div>
      <!--表格-->
      <el-table
        ref="multipleTable"
        :data="tableList"
        style="width: 100%"

        v-loading="tableLoading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
      >
      <!-- @selection-change="selectionChange" -->
        <!-- <el-table-column type="selection" width="30"></el-table-column> -->
        <el-table-column label="序号" align="left" width="50">
          <template slot-scope="scope">
            {{scope.$index | indexMethod(list.pageNo,list.pageSize)}}
          </template>
        </el-table-column>
        <el-table-column label="商品信息" prop="itemtitle" width="480">
          <template slot-scope="scope" class="shopInfo">
            <div class="shopMain">
              <img :src="scope.row.logopicurl_details?scope.row.logopicurl_details:scope.row.logopicurl" alt/>
              <div class="content">
                <el-link class="align_left two_ellipsis" :underline="false" :href="scope.row.itemlink" type="primary" target="_blank">
                  {{scope.row.itemtitle_details?scope.row.itemtitle_details:scope.row.itemtitle}}
                </el-link>
                <div class="align_left">
                  {{scope.row.productname}}
                  <el-popover placement="top-start" width="200" trigger="hover" v-show="scope.row.productname">
                    <div>
                      <div v-for="item in $options.filters.stringArray(scope.row.productprice)" :key="item">
                        <div>{{item.replace(/\"/g,"")}}</div>
                      </div>
                    </div>
                    <i class="el-icon-warning-outline" slot="reference" v-if="logintype == 'KEFU'"></i>
                  </el-popover>
                </div>
                <el-button type="primary" size="mini" plain @click="skuListChildShow(scope.row.itemid,scope.row.platformcode)" v-show="scope.row.itemtype == 2" style="margin-top: 5px">
                  SKU列表
                </el-button>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="价格"  width="300">
          <template slot-scope="scope">
            <div style="float: left;width: 100%;">
              <div v-if="scope.row.price" style="float: left;">标价：¥ {{scope.row.price}}</div>
              <div v-if="scope.row.islowprice == 'true' && logintype == 'KEFU'" class="redClass2" style="width: 39px;float: right;margin: 3px 10px;">标低</div>
              <div v-if="scope.row.islowprice == '是' && logintype != 'KEFU'" class="redClass2" style="width: 39px;float: right;margin: 3px 10px;">标低</div>
            </div>


            <div style="float: left;;width: 100%;" v-if="logintype == 'KEFU'">
              <div v-if="scope.row.contrastprice || scope.row.contrastprice != '0.0'" style="float: left;">
                到手价：¥ {{scope.row.contrastprice}}
              </div>
              <div v-if="scope.row.availableislowprice == 'true'" style="width: 51px;float: right;margin: 3px 10px;" class="redClass2">
                到手低
              </div>
            </div>

            <div style="float: left;;width: 100%;" v-if="logintype != 'KEFU'">
              <div v-if="scope.row.availableprice || scope.row.availableprice != '0.0'" style="float: left;">
                到手价：¥ {{scope.row.availableprice}}
              </div>
              <div v-if="scope.row.availableislowprice == '是'" style="width: 51px;float: right;margin: 3px 10px;" class="redClass2">
                到手低
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="250">
          <template slot-scope="scope">
            <div style="float: left;">
              <div v-show="scope.row.status=='上架'" class="have">上架</div>
              <div v-show="scope.row.status=='下架'" class="out">下架</div>
              <div v-show="scope.row.status=='已删除'" class="out">已删除</div>

              <div v-show="scope.row.camisreport == 'true'" class="have">
                <img src="https://hawksights.obs.cn-east-2.myhuaweicloud.com/ceshi/1572505655208.png" />
              </div>
            </div>
            <img
              :src='require("@/assets/img/other/zhiwen-status.png")'
              alt
              class="zhiwen_status"
              v-show="logintype!='HCM'&&scope.row.ischange=='是'"
            />
          </template>
        </el-table-column>
        <el-table-column label="优惠说明" width="320" v-if="logintype != 'KEFU'">
          <template slot-scope="scope" v-if="scope.row.coupons">
            <couponsZzj :zzjCoupons="scope.row.coupons.split(',')"/>
          </template>
        </el-table-column>
        <el-table-column label="优惠说明" width="300" v-if="logintype == 'KEFU'">
          <template slot-scope="scope">
            <couponsStyle :couponsStyle="scope.row.couponsChildList" :couponsPlatform="scope.row.platform"/>
          </template>
        </el-table-column>

        <el-table-column label="店铺/经销商" width="150">
          123123123
          <template slot-scope="scope">
            <div v-show="scope.row.shopname" class="align_left ellipsis">{{scope.row.shopname}}</div>
            <div v-show="scope.row.wangwang && newplatCode == 'TBTM'" class="align_left ellipsis">{{scope.row.wangwang}}</div>
            <div class="tall_icon">
              <img
                :src="require('@/assets/img/platform/pla_'+scope.row.platform+'.png')"
                alt
                class="edit_icon"
              />
              <span class="green" v-show="scope.row.authorize">{{scope.row.authorize}}</span>
              <span class="green" v-show="scope.row.authorize">{{scope.row.authorize}}</span>
              <span class="grey" v-show="scope.row.shoptype=='灰名单'">灰</span>
              <span class="black" v-show="scope.row.shoptype=='黑名单'">黑</span>
              <span class="green" v-show="scope.row.shoptype== '授权店铺'">授权</span>
            </div>
            <div class="align_left ellipsis">{{scope.row.dealername}}</div>
          </template>
        </el-table-column>

        <!-- <el-table-column label="店铺/经销商3" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.shopname" class="align_left ellipsis">{{scope.row.shopname}}</div>
            <div v-if="scope.row.wangwang && newplatCode == 'TBTM'" class="align_left ellipsis">{{scope.row.wangwang}}</div>
            <div class="tall_icon">
              <img
                :src="require('@/assets/img/platform/pla_'+scope.row.platform+'.png')"
                alt
                class="edit_icon"
              />
              <span class="green" v-show="scope.row.authorize">{{scope.row.authorize}}</span>
              <span class="green" v-show="scope.row.authorize">{{scope.row.authorize}}</span>
              <span class="grey" v-show="scope.row.shoptype=='灰名单'">灰</span>
              <span class="black" v-show="scope.row.shoptype=='黑名单'">黑</span>
              <span class="green" v-show="scope.row.shoptype== '授权店铺'">授权</span>
            </div>
            <div class="align_left ellipsis">{{scope.row.dealername}}</div>
          </template>
        </el-table-column> -->

        <el-table-column label="备注" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.remark1">备注1：{{scope.row.remark1}}</span>
            <br />
            <span v-if="scope.row.remark2">备注2：{{scope.row.remark2}}</span>
            <br />
            <span v-if="scope.row.remark3">备注3：{{scope.row.remark3}}</span>
          </template>
        </el-table-column>

        <el-table-column label="已拼件数" v-if="newplatCode == 'PDD'" prop="salevolume">
        </el-table-column>
        <el-table-column
          :label="newplatCode == '1688' || newplatCode == 'PDD' ? '评价数' : '累计评价'"
          v-if="newplatCode != 'DD'"
          prop="evaluate_num"
        ></el-table-column>
        <el-table-column
          label="评论数"
          v-if="newplatCode == 'DD'"
          prop="evaluate_num"
        ></el-table-column>
        <el-table-column
          prop="salevolume"
          label="月销量"
          width="100"
          v-if="newplatCode == 'TBTM'"
        ></el-table-column>
        <el-table-column
          prop="salevolume"
          label="成交量"
          width="100"
          v-if="newplatCode == '1688'"
        ></el-table-column>
        <el-table-column
          prop="area"
          label="发货地"
          width="150"
          v-if="newplatCode == 'TBTM' || newplatCode == '1688' || newplatCode == 'JD'"
        ></el-table-column>
        <el-table-column
          prop="area"
          label="运费"
          width="150"
          v-if="newplatCode == 'TBTM' || newplatCode == 'DD' || newplatCode == '1688'"
        >
          <template slot-scope="scope" v-if="scope.row.express_fee">
            {{scope.row.express_fee}}
          </template>
        </el-table-column>
        <el-table-column label="数据更新时间" width="200px" fixed="right" class-name="lastTime">
          <template slot-scope="scope">
            <span v-show="scope.row.synchrotime">{{scope.row.synchrotime | fullTime}}</span>
            <!-- <i
              class="el-icon-error"
              style="color:#f40b17;margin-left: 6px"
              @click="deletesRowShow(scope.row.id)"
              v-show='showType'
            ></i> -->
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <pagination
        v-if="tableList&&tableList.length>0"
        :currentPage="currentPage"
        :pageSizes="[10, 20, 50, 100]"
        :total="total"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>
    </div>

    <!-- sku信息 -->
    <el-dialog :visible.sync="skuShow" width="70%" title="SKU列表" id="elDialog">
      <el-table :data="skuData" style="width: 100%"
      v-loading="skuloading" element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading">
        <el-table-column label="序号" align="left" type="index" width="50">
          <template slot-scope="scope">
            {{scope.$index | indexMethod(list.pageNo,list.pageSize)}}
          </template>
        </el-table-column>
        <el-table-column prop="skuname" label="SKU名称">
          <template slot-scope="scope">
            <div class="skuname">{{scope.row.skuname}}</div>
          </template>
        </el-table-column>
        <el-table-column label="标价">
          <template slot-scope="scope">
            <div style="float: left;" v-if="logintype == 'KEFU'">
              <div v-if="scope.row.skuprice" style="float: left;">¥ {{scope.row.skuprice}}</div>
              <div v-if="scope.row.skuislowprice == 'true'" class="redClass2" style="width: 39px;float: right;margin: 3px 10px;">标低</div>
            </div>
            <div style="float: left;" v-else>
              <div v-if="scope.row.price" style="float: left;">¥ {{scope.row.price}}</div>
              <div v-if="scope.row.availableislowprice == '是'" class="redClass2" style="width: 39px;float: right;margin: 3px 10px;">标低</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="到手价">
          <template slot-scope="scope">
            <div v-if="logintype == 'KEFU'">
              <div v-if="scope.row.availableprice" style="float: left;">
                ¥ {{scope.row.availableprice}}
              </div>
              <div v-if="scope.row.skuavailableislowprice == 'true'" style="width: 51px;float: right;margin: 3px 10px;" class="redClass2">
                到手低
              </div>
            </div>
            <div v-else>
              <div v-if="scope.row.availableprice" style="float: left;">
                ¥ {{scope.row.availableprice}}
              </div>
              <div v-if="scope.row.availableislowprice == '是'" style="width: 51px;float: right;margin: 3px 10px;" class="redClass2">
                到手低
              </div>
            </div>

          </template>
        </el-table-column>
        <el-table-column prop="name" label="状态" v-if="logintype == 'KEFU'">
          <template slot-scope="scope">
            <img :src='require("@/assets/img/other/zhiwen-status.png")'
              alt
              class="zhiwen_status"
              v-show="scope.row.ischange=='是'"
            />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="产品">
          <template slot-scope="scope">
            <div class="productname">
              <span v-if="scope.row.productid">
                <span v-if="scope.row.productid.length > 20">{{scope.row.productName}}</span>
                <span v-else>限价标准：¥{{scope.row.productid}}</span>
              </span>
              {{scope.row.productname}}
              <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                v-show="scope.row.productName"
              >
                <div>
                  <div
                    v-for="item in  $options.filters.stringArray(scope.row.skuProductPrice)"
                    :key="item"
                  >
                    <div>{{item.replace(/\"/g,"")}}</div>
                  </div>
                </div>
                <i class="el-icon-warning-outline" slot="reference"></i>
              </el-popover>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-if="tableList&&tableList.length>0"
        :currentPage="currentPage2"
        :pageSizes="[10, 20, 50, 100]"
        :total="total2"
        @handleSizeChange="handleSizeChange2"
        @handleCurrentChange="handleCurrentChange2"
      ></pagination>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="productShow" width="360px" style="margin-top: 10%;" id="dialog">
      <div style="display: flex;width: 100%;justify-content:center;">
        <i class="el-icon-warning" style="color:#faad14;font-size: 25px;"></i>
        <div>
          <div style="font-size: 16px;">选择不需要下载的产品</div>
        </div>
      </div>
      <div style="margin-top: 10px;">
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="产品信息" label-width="100px">
            <el-select v-model="productid" multiple placeholder="请选择" size="small">
              <el-option
                v-for="item in options2"
                :key="item.id"
                :label="item.productClassifyName"
                :value="item.id">
              </el-option>
            </el-select>
            <!-- <el-cascader
              filterable
              clearable
              size="small"
              v-model="productid"
              :options="options2"
              :props="productidChildren"
              collapse-tags
              @change="handleChange"
              @visible-change="getListBybmcid2"
              style="width: 100%;"
              :disabled="cascaderDisabled"
            ></el-cascader> -->
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="downTable" size="small" type="primary">确 定</el-button>
        <el-button @click="productShow = false" size="small" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>
    <!-- sku信息 -->
    <!-- 删除 -->
    <!-- <el-dialog
      :visible.sync="deleteShow"
      width="20%"
      title="删除"
      style="margin-top: 10%;height: 346px;"
      id="elDialog2"
    >
      <div style="display: flex;width: 100%;justify-content:center;line-height: 35px;">
        <i class="el-icon-warning" style="color:#faad14;font-size: 35px;margin-right: 10px;"></i>
        <div>
          <div style="font-size: 16px;">你确认要删除{{numberOf}}条商品信息吗？</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="sureDelete()" size="small">确 定</el-button>
        <el-button @click="qxDelete" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
      </div>
    </el-dialog> -->
    <!-- 删除 -->
  </div>
</template>
<script>
import pagination from "../../../components/dataTable/pagination";
import aes from "@/libs/aes";
import couponsStyle from "@/components/couponsStyle";
import couponsZzj from "@/components/couponsZzj";

export default {
  name: "brandStore",
  data() {
    return {
      productShow: false,
      productid: [],
      options2: [],
      cascaderDisabled: false,
      productidChildren: {
        multiple: true,
        value: "id",
        label: "productClassifyName",
        children: "children"
      },
      skuloading: true,
      lowPriceLoading: false,
      toPath:{ path: '/Brand/BrandMerchandise/lowPriceSearch' },
      pageNo: 1,
      pageSize: 10,
      currentPage2: 1,
      total2: 1,
      itemid: "",
      skuData: [],
      skuShow: false,
      tableLoading: false,
      multipleSelection: [],
      deleteShow: false,
      checkAll: 0,
      openNumber: 0,
      logintype: "",
      numberOf: "该",
      platformCode: "TBTM",
      dictCodeShow: "TB",
      platformShow: true,
      formLabelWidth: "100px",
      tableList: [],
      currentPage: 1,
      total: "",
      batchUserIds: "",
      list: {
        pageNo: 1,
        pageSize: 10,
        platform: '',
        starttime: this.$route.query.date.substring(0,this.$route.query.date.length - 9),
        itemtitle: "",
        shopname: "",
        productName: "",
        remark: "",
        status: [],
      },
      showType:true,
      newplatCode: '',
    };
  },
  components: {
    pagination,
    couponsStyle,
    couponsZzj
  },
  filters: {
    stringArray: function(value) {
      if (value) {
        let newValue;
        newValue = value.substr(0, value.length - 1);
        return newValue.substr(1, value.length - 1).split(",");
      }
    },
    objToAr: aes.objToArr
  },
  mounted() {
    this.getListBybmcid2()
    this.logintype = JSON.parse(localStorage.getItem("userData")).logintype; //登录账号类型
    console.log(this.logintype)
    if (this.$route.query.platform) {
      this.list.platform = this.$route.query.platform
      this.newplatCode = this.$route.query.platform
    } else if (this.$route.query.platformCode) {
      this.list.platform = this.$route.query.platformCode
      this.newplatCode = this.$route.query.platformCode
    }
    console.log(this.$route.query)
    if(this.$route.query.type && this.$route.query.type===1) {
      this.showType=false
      this.toPath={ path: '/Brand/BrandMerchandise/DailyLowPrice' }
    }

    this.getIprPluginListList();

    if (
      this.list.platform == "TBTM" ||
      this.$route.query.platformCode == "TBTM"
    ) {
      this.platformShow = true;
    } else {
      this.platformShow = false;
    }
    console.log(this.$route.query.type)
  },
  computed: {},
  methods: {
    handleChange(value) {
      this.productid = value
    },
    getListBybmcid2(data) {
      // if (data == true && this.options2.length == 0) {
      //   this.cascaderDisabled = true
        fetch({
          url: "hcm/hcmProduct/getListBybmcid",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(res => {
          let result = JSON.parse(res);
          if (result.status == "10000") {
            this.options2 = result.data;
            // this.cascaderDisabled = false
          }
        });
      // }
    },
    downTable(row) {
      this.lowPriceLoading = true
      let params = {
        platform: this.list.platform,
        starttime: !this.showType?this.$route.query.date:this.list.starttime,
        ischange: "null"
      };
      console.log(this.productid)
      if (this.productid.length > 0) {
        // let products = []
        // for (let a in this.productid) {
        //   let b = this.productid[a]
        //   products.push(b[1].split(',')[0])
        // }
        // params.products = products.join(',')
        params.products = this.productid.join(',')
      }
      console.log(this.showType)
      if (this.list.itemtitle) {
        params.itemtitle = this.list.itemtitle;
      }
      if (this.list.shopname) {
        params.shopname = this.list.shopname;
      }
      if (this.list.status) {
        params.status = this.list.status.join(',');
      }
      if (this.list.remark) {
        params.remark = this.list.remark;
      }
      if (this.list.productName) {
        params.productName = this.list.productName;
      }
      fetch({
        url: "hcm/iprPluginList/exportLowPriceList",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "blob",
        timeout: 60 * 1000 * 30
      }).then(res => {
        //下载
        let url = window.URL.createObjectURL(new Blob([res]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", "日常违规检索详情.xlsx");
        document.body.appendChild(link);
        link.click();
        this.lowPriceLoading = false
        this.productShow = false
      });
    },
    exportExcelStatistics() {
      this.lowPriceLoading = true
      let params = {
        platform: this.list.platform,
        starttime: !this.showType?this.$route.query.date:this.list.starttime,
        ischange: "null",
        type: 1
      };
      if (this.list.itemtitle) {
        params.itemtitle = this.list.itemtitle;
      }
      if (this.list.shopname) {
        params.shopname = this.list.shopname;
      }
      if (this.list.status) {
        params.status = this.list.status.join(',');
      }
      if (this.list.remark) {
        params.remark = this.list.remark;
      }
      if (this.list.productName) {
        params.productName = this.list.productName;
      }
      fetch({
        url: "hcm/iprViolationRetrieveData/downloadIprLowPriceListByAllbmc",
        method: "post",
        params: params,
        noFormat: true,
        responseType: "blob",
        timeout: 60 * 1000 * 30
      }).then(res => {
        //下载
        let url = window.URL.createObjectURL(new Blob([res]));
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", "日常违规检索详情.xlsx");
        document.body.appendChild(link);
        link.click();
        this.lowPriceLoading = false
      });
    },
    // 查询
    getIprPluginListList(e) {
      this.tableLoading = true
      if (e == 1) {
        this.list.pageNo = 1;
      }
      let datas = {
        pageNo: this.list.pageNo,
        pageSize: this.list.pageSize,
        // platform: this.list.platform,
        starttime: !this.showType?this.$route.query.date:this.list.starttime
      };
       console.log(this.showType)
      if (this.list.itemtitle) {
        datas.itemtitle = this.list.itemtitle;
      }
      if (this.list.shopname) {
        datas.shopname = this.list.shopname;
      }
      if (this.list.status) {
        datas.status = this.list.status.join();
      }
      if (this.list.remark) {
        datas.remark = this.list.remark;
      }
      if (this.list.productName) {
        datas.productName = this.list.productName;
      }
      let url
      if (this.logintype == 'KEFU') {
        datas.platform = this.list.platform
        url = "hcm/iprPluginList/getLowPriceList"
      } else {
        datas.platformcode = this.list.platform
        url = "hcm/iprViolationRetrieveData/getIprViolationRetrieveDataList"
      }
      fetch({
        url: url,
        method: "get",
        params: datas,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res;
        if (res.status == "10000") {
          this.tableLoading = false
          this.tableList = data.content;
          this.total = data.totalElements;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // selectionChange(val) {
    //   this.multipleSelection = val;
    //   console.log(this.multipleSelection);
    // },
    // SKU列表
    skuListChildShow(itemid,platformcode) {
      if (platformcode) {
        this.platformcode = platformcode
      }
      this.skuloading = true
      let syncDate = this.$route.query.date;
      if (itemid) {
        this.itemid = itemid;
      }
      this.skuShow = true;
      let datas = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        itemid: this.itemid,
        syncdate: syncDate.substring(0, 10),
        platformcode: this.platformcode,
      };
      let url
      if (this.logintype == 'KEFU') {
        url = "hcm/iprPluginList/getLowPriceSkuList"
      } else {
        url = "hcm/iprViolationRetrieveData/getIprViolationRetrieveDataSkuList"
      }
      fetch({
        url: url,
        method: "get",
        params: datas,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let { data } = res;
        if (res.status == "10000") {
          this.skuloading = false
          this.skuData = data.content;
          this.total2 = data.totalElements;
        } else {
          this.skuloading = false
          this.$message.error(res.message);
        }
      });
    },
    //每页
    handleSizeChange(val) {
      this.list.pageSize = val;
      this.getIprPluginListList();
    },
    //当前页
    handleCurrentChange(val) {
      this.list.pageNo = val;
      this.getIprPluginListList();
    },
    handleSizeChange2(val) {
      this.pageSize = val;
      this.skuListChildShow();
    },
    handleCurrentChange2(val) {
      this.pageNo = val;
      this.skuListChildShow();
    }
  }
};
</script>

<style lang="scss">
  @import "style/lowPriceDetails.scss";
</style>
